module.exports = __webpack_public_path__ + "images/8c523d6b1be65808b9702cc5a27d9ac0.webp";